import Vue from 'vue'
import Vuex from 'vuex'

import beneficiaries from '@/store/modules/beneficiaries'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    beneficiaries
  }
})
